import {
  Stack,
  Typography,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { useContentData } from "./layout";
import CommentIcon from "@mui/icons-material/Comment";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { LanguageCode } from "types";

import VideoPlayer from "components/VideoPlayer";

const Content = () => {
  console.log("Content");
  const navigate = useNavigate();
  const { content } = useContentData();
  const { id, language } = useParams();
  if (!language) {
    navigate(`/content/${id}/${content.originalLanguage}`);
  }
  console.log("content", content);
  console.log("language", language);
  const translationData =
    content.translatedLanguages[language! as LanguageCode];

  const source = translationData?.merge_file;
  const title = translationData?.title || content.title;
  const description = translationData?.description || content.description;

  console.log("source", source);
  console.log("title", title);
  console.log("description", description);

  return (
    <Stack>
      <Stack
        direction="row"
        spacing={8}
        sx={{ pl: 7.5, pr: 4, justifyContent: "space-between" }}
      >
        <Stack>
          <Stack direction={"row"} sx={{ py: 3 }}>
            <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
              {`Full ${content.type} Preview`}
            </Typography>
            {/* TODO: PUBLISHED */}
            {/* TODO: Feedback */}
          </Stack>
          <Stack
            direction={content.type === "video" ? "row" : "column"}
            spacing={4}
          >
            {content.type === "video" ? (
              <Box>
                {source ? (
                  <VideoPlayer type={content.type} contentUrl={source} />
                ) : (
                  <p>Loading video...</p>
                )}
              </Box>
            ) : (
              // TODO: replace with audio player component
              <audio controls>
                <source src={source} type="audio/mpeg" />
              </audio>
            )}
            <Stack>
              <Typography variant="h4">{title}</Typography>
              <Typography variant="caption" sx={{ color: "black", pt: 2 }}>
                {description}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack sx={{ minWidth: 255 }}>
          <Typography
            variant="body1"
            sx={{ py: 3, textTransform: "uppercase", fontWeight: 500 }}
          >
            Actions
          </Typography>
          <List>
            <ListItemButton
              component={RouterLink}
              to={`/content/${id}/${language}/transcript`}
              disableGutters
            >
              <ListItemIcon>
                <CommentIcon
                  fontSize="large"
                  sx={{
                    color: "background.default",
                    bgcolor: "primary.main",
                    borderWidth: 8,
                    borderStyle: "solid",
                    borderColor: "primary.main",
                    borderRadius: 2,
                  }}
                />
              </ListItemIcon>

              <ListItemText
                primary="View / Edit Transcript"
                secondary="Download and modify"
              />
              <ChevronRightIcon />
            </ListItemButton>
            <Divider />
          </List>
        </Stack>
      </Stack>
      {/* Content Shorts */}
    </Stack>
  );
};

export default Content;
